import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

const hostname = window.location.host;
// const test = 'https://ruentex-api-server.eilis-ai.com/api/test/';
const test = 'https://ruentex-api-server.eilis-ai.com/api/v1/'; // 本地端測試 正式站API用
const official = 'https://ruentex-api-server.eilis-ai.com/api/v1/';
const CryptoJS = require('crypto-js');
Vue.use(Vuex);
/* eslint-disable */

const state = {
  infomation: {
    brand: localStorage.getItem('brand'),
  },
  couponList: [{
        item: [],
        type: "載入中"
    }],
  tempInfo: {
    address: '',
    email: '',
    birth: '',
  },
  brandCode: '',
  tempIndex: '',
  tempRecord: [],
  counterList: [],
  eilisProfile: [],
  ruentexProfile: [], // 首頁抓取潤泰個人資料
  info: {
    brand: '',
    clientId: '' || localStorage.getItem('clientId'),
    token: '',
    phone: '',
    // phone: '0987747267',
    // phone: '0926724606',
    birth: '',
    name: '',
  },
}
const getters = {
  tempInfo: state => state.tempInfo,
  counterList: state => state.counterList,
  brandCode:  state => state.brandCode,
  couponList: state => state.couponList,
  eilisProfile: state => state.eilisProfile,
  ruentexProfile: state => state.ruentexProfile,
  info: state => state.info,
  tempRecord: state => state.tempRecord,
  tempIndex: state => state.tempIndex,
  // register: state => state.register,
  // shopNo: state => state.shopNo,
  // storeInfo: state => state.storeInfo,
  // returnCode: state => state.returnCode
}
const actions = {
  // 查詢店櫃列表（EILIS）
  getStoreList({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}getSaleroom`;
    } else {
      apiUrl = `${official}getSaleroom`;;
    }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getTransactionRecord';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      clientId: contents.clientId,
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
  // 查詢兌換記錄（EILIS）
  getCouponHistory({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}getExchangeRecord`;
    } else {
      apiUrl = `${official}getExchangeRecord`;;
    }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getTransactionRecord';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      clientId: contents.clientId,
      dateClose: contents.end,
      dateStart: contents.begin,
      storeId: contents.storeId,
      phone: contents.phone,
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
  // 潤泰兌換會員優惠券 (潤泰)
  getruentexCoupon({ commit, store }, contents) {
    let apiUrl = ''
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    apiUrl = `https://etrade-ruentex.eilis-ai.com/v1/getUserCoupon`;
    // if ((localStorage.getItem('brand') === 'Whittard' && hostname.indexOf('ruentex-vip-test') !== -1) || (localStorage.getItem('brand') === 'Whittard' && hostname.indexOf('localhost') !== -1)) {
    //   apiUrl = `https://etrade-ruentex.eilis-ai.com/test/getUserCoupon`;
    // } else {
    //   apiUrl = `https://etrade-ruentex.eilis-ai.com/v1/getUserCoupon`;
    // }
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getUserCoupon';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      brand: contents.brand,
      registerno: contents.registerno,
      custid: contents.custId,
      mode: 'ONLINE'
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
  },
  // 兌換優惠券
  redeemCoupon({ commit, store }, contents) {
    let apiUrl = ''
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}exchange`;
    } else {
      apiUrl = `${official}exchange`;
      // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getCoupon';
    }
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/exchange';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      clientId: contents.clientId,
      itemNo: contents.itemNo,
      phone: contents.phone,
      date: contents.date,
      serialNo: contents.serialNo,
      point: contents.point
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
  },
  // 取得優惠券序號
  getCouponNumber({ commit, store }, contents) {
    // const hostname = window.location.host;
    let apiUrl = ''
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getCoupon';
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}getCoupon`;
    } else {
      apiUrl = `${official}getCoupon`;
      // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getCoupon';
    }
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      clientId: contents.clientId,
      itemNo: contents.itemNo
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
  },
  // 取得商品列表
  getCoupon({ commit, store }, contents) {
    // const hostname = window.location.host;
    let apiUrl = ''
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}getItemList`;
    } else {
      // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getItemList';
      apiUrl = `${official}getItemList`;;
    }
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      clientId: contents.clientId,
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
},
  // 查詢交易資料（EILIS）
  getRecord({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}getTransactionRecord`;
    } else {
      apiUrl = `${official}getTransactionRecord`;;
    }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getTransactionRecord';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      clientId: contents.clientId,
      dateClose: contents.end,
      dateStart: contents.begin,
      storeId: contents.storeId,
      phone: contents.phone,
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
  // 中華電信API
  ChTextMsg({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    const apiUrl = 'https://etrade-ruentex.eilis-ai.com/v1/sendSMS';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      phone: contents.phone,
      brand: contents.brand,
      msg: contents.msg
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
  },
  // 檢查電話是否註冊過
  checkPhoneNumbers({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}getUserByPhone`;
    } else {
      // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getItemList';
      apiUrl = `${official}getUserByPhone`;;
    }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getUserByPhone';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      phone: contents.phone,
      // service: contents.service,
      clientId: contents.clientId
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
  },
  // 檢查會員（使用 token）
  checkUserByToken({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}checkUserByToken`;
    } else {
      // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getItemList';
      apiUrl = `${official}checkUserByToken`;
    }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/checkUserByToken';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      service: contents.service,
      token: contents.token,
      clientId: contents.clientId
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
  // 查詢會員（潤泰）
  readMember({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    apiUrl = `https://etrade-ruentex.eilis-ai.com/v1/readMember`;
    // if ((localStorage.getItem('brand') === 'Whittard' && hostname.indexOf('ruentex-vip-test') !== -1) || (localStorage.getItem('brand') === 'Whittard' && hostname.indexOf('localhost') !== -1)) {
    //   apiUrl = `https://etrade-ruentex.eilis-ai.com/test/readMember`;
    //   // apiUrl = `${official}readMember`;
    // } else {
    //   apiUrl = `https://etrade-ruentex.eilis-ai.com/v1/readMember`;
    // }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://etrade-ruentex.eilis-ai.com/v1/readMember';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      birth: contents.birth,
      phone: contents.phone,
      custid: contents.clientId,
      brand: contents.brand
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
  // 修改會員 (潤泰)
  updateMember({ commit, store }, contents) {
    // console.log(contents);
    // return;
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    apiUrl = `https://etrade-ruentex.eilis-ai.com/v1/updateMember`;
    // if ((localStorage.getItem('brand') === 'Whittard' && hostname.indexOf('ruentex-vip-test') !== -1) || (localStorage.getItem('brand') === 'Whittard' && hostname.indexOf('localhost') !== -1)) {
    //   apiUrl = `https://etrade-ruentex.eilis-ai.com/test/updateMember`;
    // } else {
    //   // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getItemList';
    //   apiUrl = `https://etrade-ruentex.eilis-ai.com/v1/updateMember`;
    // }
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      name: contents.name,
      brand: contents.brand,
      custid: contents.custid,
      phone: contents.phone,
      lineid: contents.lineid,
      fbid: contents.fbid,
      email: contents.email,
      zip: contents.zip,
      city: contents.city,
      town: contents.town,
      address: contents.address,
      birth: contents.birth
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
  // 新增會員 (潤泰)
  addMember({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    apiUrl = `https://etrade-ruentex.eilis-ai.com/v1/addMember`;
    // if ((localStorage.getItem('brand') === 'Whittard' && hostname.indexOf('ruentex-vip-test') !== -1) || (localStorage.getItem('brand') === 'Whittard' && hostname.indexOf('localhost') !== -1)) {
    //   apiUrl = `https://etrade-ruentex.eilis-ai.com/test/addMember`;
    // } else {
    //   // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getItemList';
    //   apiUrl = `https://etrade-ruentex.eilis-ai.com/v1/addMember`;
    // }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://etrade-ruentex.eilis-ai.com/v1/addMember';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      brand: contents.brand,
      name: contents.name,
      phone: contents.phone,
      birth: contents.birth,
      lineid: contents.lineid,
      gender: contents.gender,
      saleroom: contents.saleroom,
      email: contents.email, // N
      address: contents.address, // N
      fbid: contents.fbid, // N
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
  // 註冊會員 (ＥＩＬＩＳ)
  registerEilis({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}register`;
    } else {
      // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getItemList';
      apiUrl = `${official}register`;;
    }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/register';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      service: contents.service,
      clientId: contents.clientId,
      token: contents.token,
      phone: contents.phone,
      userId: contents.userId,
      name: contents.name,
      birth: contents.birth,
      profileImg: contents.profileImg
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
  // 修改電話 (ＥＩＬＩＳ)
  updatePhoneNumber({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}changePhone`;
    } else {
      // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getItemList';
      apiUrl = `${official}changePhone`;;
    }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/changePhone';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      clientId: contents.clientId,
      oldPhone: contents.oldPhone,
      newPhone: contents.newPhone,
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
  // 更新會員 (ＥＩＬＩＳ)
  updateMemberEilis({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}updateUser`;
    } else {
      // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getItemList';
      apiUrl = `${official}updateUser`;;
    }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/updateUser';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      clientId: contents.clientId,
      phone: contents.phone,
      name: contents.name,
      birth: contents.birth,
      address: contents.address,
      gender: contents.gender,
      email: contents.email,
      detail: contents.detail,
      zip: contents.zip
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
  // 快速通關 (ＥＩＬＩＳ)
  fastClearance({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    let apiUrl = ''
    if (hostname.indexOf('ruentex-vip-test') !== -1 || hostname.indexOf('localhost') !== -1) {
      apiUrl = `${test}fastClearance`;
    } else {
      // apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/getItemList';
      apiUrl = `${official}fastClearance`;;
    }
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    // const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/v1/fastClearance';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      service: contents.service,
      clientId: contents.clientId,
      token: contents.token,
      userId: contents.userId,
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
}
const mutations = {
  storeTempInfo(state, { tempInfo }) {
    // console.log(Efile);
    state.tempInfo = tempInfo
  },
  updateBrand(state, { brand }) {
    // console.log(Efile);
    state.info.brand = brand
  },
  updateList(state, { list }) {
    // console.log(Efile);
    state.counterList = list
  },
  transform(state, { code }) {
    // console.log(code);
    if (code === 'NAUTICA') {
      state.brandCode = 'NS';
    } else if (code === 'JEEP') {
      state.brandCode = 'JP';
    } else if (code === 'Eden Park') {
      state.brandCode = 'EP';
    } else if (code === 'Lulu Guinness') {
      state.brandCode = 'LU';
    } else if (code === 'Whittard') {
      state.brandCode = 'WH';
    } else if (code === 'LIP SERVICE') {
      state.brandCode = 'LP';
    }
  },
  storeEilisFile(state, { Efile }) {
    // console.log(Efile);
    state.eilisProfile = Efile
  },
  storeRuenFile(state, { Profile }) {
    // console.log(Profile);
    state.ruentexProfile = Profile
  },
  updateCouponList(state, { couponList }) {
    // console.log(clientId);
    state.couponList = couponList
  },
  updateClientId(state, { clientId }) {
    // console.log(clientId);
    state.info.clientId = clientId
  },
  updatetoken (state, { token }) {
    state.info.token = token
  },
  updatephone (state, { phone }) {
    state.info.phone = phone
  },
  updateRecord(state, { record }) {
    console.log(record);
    state.tempRecord = record
    // console.log(shopCart);
  },
  updateIndex(state, { index }) {
    // console.log(index);
    state.tempIndex = index
    // console.log(shopCart);
  }
}
export default {
    state,
    getters,
    actions,
    mutations
}